// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"362":"d8da7cf2","806":"d35147d8"}[chunkId] + ".chunk.css";
};